import React from "react";
import "./App.css";
import Intro from "./components/Intro";
import About from "./components/About";
import Contact from "./components/Contact";
import Work from "./components/Work";

function App() {
  console.log("App component rendering");

  return (
    <div className="App">
      {/* Sticky Logo */}
      <div className="sticky-logo">
        <img
          src="/images/atømik brunei logo.svg"
          alt="Atømik Brunei Logo"
          className="logo-image"
        />
      </div>

      <Intro />
      <About />
      <Work />
      <Contact />
    </div>
  );
}

export default App;
